/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Skin_Hair_TypeInputs */

const en_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Type`)
};

const es_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo objetivo`)
};

const fr_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type cible`)
};

const de_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieltyp`)
};

const ja_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象となる肌/髪のタイプ`)
};

const zh_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用目标类型`)
};

const ar_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع المستهدف (بشرة/شعر)`)
};

const id_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Target`)
};

const it_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per tipo di pelle/capelli`)
};

const ru_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип кожи/волос`)
};

const pt_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo Alvo`)
};

const ko_field_skin_hair_type = /** @type {(inputs: Field_Skin_Hair_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대상 유형`)
};

/**
* | output |
* | --- |
* | "Target Type" |
*
* @param {Field_Skin_Hair_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_skin_hair_type = /** @type {((inputs?: Field_Skin_Hair_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Skin_Hair_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_skin_hair_type(inputs)
	if (locale === "es") return es_field_skin_hair_type(inputs)
	if (locale === "fr") return fr_field_skin_hair_type(inputs)
	if (locale === "de") return de_field_skin_hair_type(inputs)
	if (locale === "ja") return ja_field_skin_hair_type(inputs)
	if (locale === "zh") return zh_field_skin_hair_type(inputs)
	if (locale === "ar") return ar_field_skin_hair_type(inputs)
	if (locale === "id") return id_field_skin_hair_type(inputs)
	if (locale === "it") return it_field_skin_hair_type(inputs)
	if (locale === "ru") return ru_field_skin_hair_type(inputs)
	if (locale === "pt") return pt_field_skin_hair_type(inputs)
	return ko_field_skin_hair_type(inputs)
});